import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { useBookingHasFee } from 'reservations/booking/providers/BookingProvider';

export const useShouldAuthenticateForCancel = () => {
  const hasFeePolicy = useBookingHasFee();
  const hasVisitId = useHasVisitId();

  return hasFeePolicy || hasVisitId;
};
